<!--<div>
  <div >
    <button class="btn btn-default" type="button" [routerLink]='["/"]'>
      Back
    </button>
    <label class="lbl-text">Property Search in:</label>
    <label>South Essex</label>
  </div>
  <div class="ml-10">
    <label class="lbl-text">Searching:</label>
    <label>Deeds</label>

    <label class="lbl-text">Date:</label>
    <label>02-25-2019</label>

    <label class="lbl-text">to</label>
    <label>02-25-2019</label>

    <label class="lbl-text">Business/LastName:</label>
    <label>XXX</label>
  </div>
</div>-->

<div class="info-strip grid clearfix">
  <div class="info-strip-left grid">
    <button class="back-button" type="button" (click)="back('/rodcore')">
      <i class="fa fa-caret-left"></i><p>Back</p>
    </button>
  </div>
  <!--<div class="info-strip-right grid" *ngFor="let r of recs.rec ">-->
  <div class="info-strip-right grid">
    <div class="criteria">
      <h2>Property Search Results</h2>
      <p>
        <strong>Name:</strong> {{ recs.name[0].lastcorpName }}   
        <strong>Date:</strong> {{recs.date[0].fromDate| date:'MM-dd-yyyy'}} to {{recs.date[0].toDate| date:'MM-dd-yyyy'}}   <strong>City/Town:</strong> <label *ngIf="towns.length===0">All</label><label *ngIf="towns.length>2">Multiple</label><label *ngIf="towns.length===2">{{towns[0]}},{{towns[1]}}</label><label *ngIf="towns.length===1">{{towns[0]}}</label>  <strong>{{recordCount}}</strong> records found
      </p>
    </div>
    <!--<div class="grid-right-icons">
      <img tabindex="0" class="email-img" src="images/email.png">
      <div class="filter-toggle"><p>Filter Results ></p></div>
    </div>-->
  </div>
</div>
